"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractQuery = void 0;
class AbstractQuery {
    constructor() {
        this._query = {};
    }
    /**
     * Adds and defines the property attributed to the SCHEMA and the associated field (optional) to search.
     *
     * @param prop A property based on the provided SCHEMA
     * @param data A property-specific data definition that will define the query
     * @param config
     *   @param field A field to search
     *   @param identifier A name or identifier of the query
     * @returns SCHEMA-specific
     */
    addProp(prop, data, config) {
        return this.updateQuery(prop, data, config);
    }
    /**
     * Adds and defines custom property attributed to the SCHEMA and the associated field (optional) to search.
     * @param prop A custom property
     * @param data The data definition of the custom property
     * @returns SCHEMA-specific
     */
    addCustomProp(prop, data, config) {
        return this.updateQuery(prop, data, config);
    }
    /**
     * Generates the SCHEMA-specific query.
     *
     * If the query is defined within another query, generating the main query will also generate nested queries, so there's no need to generate them.
     * @returns
     */
    generate() {
        this.parseNestedQuery(this._query);
        return this._query;
    }
    parseNestedQuery(query) {
        for (const [key, value] of Object.entries(query)) {
            if (Array.isArray(value)) {
                this.parseNestedQuery(value);
            }
            else if (typeof value === 'object' && value !== null) {
                query[key] = this.generateNestedQuery(value);
                this.parseNestedQuery(value);
            }
            else {
                query[key] = this.generateNestedQuery(value);
            }
        }
    }
    generateNestedQuery(query) {
        if (query instanceof (AbstractQuery)) {
            return query.generate();
        }
        return query;
    }
    updateQuery(prop, data, config) {
        var _a;
        let model = this._query;
        if (config) {
            const { field, identifier, parentIdentifier } = config;
            if (parentIdentifier) {
                model = (_a = this.findObjectByPropertyName(parentIdentifier)) !== null && _a !== void 0 ? _a : this._query;
            }
            if (field && !identifier) {
                model[prop] = { [field]: data };
            }
            else if (identifier && !field) {
                model[identifier] = { [prop]: data };
            }
            else if (field && identifier) {
                model[identifier] = { [prop]: { [field]: data } };
            }
            else {
                model[prop] = data;
            }
        }
        else {
            model[prop] = data;
        }
        return this;
    }
    findObjectByPropertyName(propertyName) {
        const model = this._query;
        if (model.hasOwnProperty(propertyName)) { // eslint-disable-line no-prototype-builtins
            for (const key in model) {
                if (key === propertyName) {
                    return model[key];
                }
                const value = model[key];
                if (value && typeof value === 'object') {
                    return this.findObjectByPropertyName(propertyName);
                }
            }
        }
        else {
            console.error(`%c ERROR: Parent node ${propertyName} doesn't exist.`, 'color: red; font-family: Monospace');
        }
        return null;
    }
}
exports.AbstractQuery = AbstractQuery;
